// extracted by mini-css-extract-plugin
export default {"modal":"LessonDetailsModal_modal__p743t","footer":"LessonDetailsModal_footer__HvbnQ","btn":"LessonDetailsModal_btn__wyFuk"};